 
import React from 'react';
import { Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

function PieChartDistribution({ dataArray, field, title }) {
  if (!dataArray || !Array.isArray(dataArray) || dataArray.length === 0) {
    return <p>No hay datos para {title}</p>;
  }

   
  const counts = {};
  dataArray.forEach(item => {
    const value = item[field] ?? 'Sin dato';
    const key = String(value);

    if (!counts[key]) {
      counts[key] = 0;
    }
     
    counts[key] += item.total || 0;
  });

  // labels y valores
  const labels = Object.keys(counts);
  const values = Object.values(counts);

  const baseColors = [
    'rgba(255, 99, 132, 0.6)',
    'rgba(54, 162, 235, 0.6)',
    'rgba(255, 206, 86, 0.6)',
    'rgba(75, 192, 192, 0.6)',
    'rgba(153, 102, 255, 0.6)',
    'rgba(255, 159, 64, 0.6)',
  ];

  // Generar más colores si hace falta
  while (baseColors.length < labels.length) {
    const randomColor = `rgba(${Math.floor(Math.random() * 256)}, 
                              ${Math.floor(Math.random() * 256)}, 
                              ${Math.floor(Math.random() * 256)}, 
                              0.6)`;
    baseColors.push(randomColor);
  }

  const chartData = {
    labels,
    datasets: [
      {
        label: title,
        data: values,
        backgroundColor: baseColors.slice(0, labels.length),
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          font: {
            size: 14,
          },
        },
      },
      title: {
        display: true,
        text: title,
        font: {
          size: 16,
        },
      },
    },
  };

  return <Pie data={chartData} options={options} />;
}

export default PieChartDistribution;
